import React from 'react'
import styled from 'styled-components'
import ReactMarkdown from 'react-markdown'
import { MoonLoader } from 'react-spinners'
import { baseResourceURL } from '../conf'

export default class ViewerPage extends React.Component {
  state = {
    isLoading: true,
    error: '',
    markdown: '',
  }


  componentDidMount () {
    const { params } = this.props.match
    console.log('Resource from:', resourceURL(params.policy))

    fetch(resourceURL(params.policy))
      .then(response => response.text())
      .then(markdown => this.setState({ markdown }))
      .catch(response => this.setState({ error: response }))
      .finally(() => {
        this.setState({ isLoading: false })
      })
  }

  render () {
    return (
      <Container>
        {this.renderContent()}
        {this.renderLoading()}
        {this.renderError()}
      </Container>
    )
  }

  renderContent () {
    const { markdown, error, isLoading } = this.state

    if (!error && !isLoading) {
      return (
        <React.Fragment>
          <ReactMarkdown source={markdown}/>
          <Footer>
            Trazo Labs SpA 2020
          </Footer>
        </React.Fragment>
      )
    }
  }

  renderError () {
    const { error } = this.state

    if (error) {
      return (
        <Error>This policy does not exist or is temporarily unavailable</Error>
      )
    }
  }

  renderLoading () {
    const { isLoading } = this.state

    if (isLoading) {
      return (
        <Loading>
          <MoonLoader size={60}/>
        </Loading>
      )
    }
  }
}

const resourceURL = (name) => `${baseResourceURL}${name}.md`

const Container = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: 20px 0;
  padding-bottom: 50px;
  padding-top: 100px;
  padding-bottom: 100px;
  color: #444;
  box-sizing: border-box;
  font-weight: 300;
  
  p {
    line-height: 30px;
  }   
`

const Footer = styled.div`
  border-top: 1px solid #dedede;
  margin-top: 100px;
  padding-top: 10px;
  padding-bottom: 50px;
`

const Error = styled.h2`
  margin-top: 100px;
  text-align: center;
  font-weight: 300;  
`

const Loading = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 100px 0;
`
